// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"e34db563","287":"ea94817a","446":"9e0f4fba","564":"e2aaa433","954":"a15760b8"}[chunkId] + ".chunk.js";
};